module.exports = __webpack_public_path__ + "static/img/logo.c5d5e033.png";